import { render } from "./app.vue?vue&type=template&id=746d5e50&scoped=true"
const script = {}

import "./app.vue?vue&type=style&index=0&id=746d5e50&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746d5e50"]])

export default __exports__